import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from "react-loader";

import withServices from "../../HOCs/withServices";
import Navbar from "../../components/CustomNav/CustomNav.Component";
import SummaryInfo from "../../components/DataCentre/SummaryInfo";
import CoursePicker from "../../components/DataCentre/CoursePicker";
import PerformanceGraph from "../../components/DataCentre/PerformanceGraph";
import StudentsPerformance from "../../components/DataCentre/StudentsPerformance";
import DatePicker from "../../components/DatePicker/DatePickerComponent";

import {
  Wrapper,
  Content,
  ContentRow,
  ContentCol,
  HeaderRow,
} from "./DataCentre.styles";
import { currentUser } from "src/common/services";
import { toast } from "react-toastify";
import { PickerHeader } from "./CourseDetails/CourseDetails.styles";

interface IProps {
  services?: any;
  isParent?: boolean;
  isSchool?: boolean;
  isTeacher?: boolean;
  history: any
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  isLoading: boolean;
  data: any;
  selectedCourse: string;
  startDateObj?: unknown;
  endDateObj?: unknown;
  startDate: string;
  endDate: string;
  enrolledLearners?: [];
}

class DataCentre extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      toLogin: false,
      loaded: false,
      isLoading: false,
      data: {},
      selectedCourse: "",
      startDateObj: null,
      startDate: "",
      endDateObj: null,
      endDate: "",
      enrolledLearners: [],
    };

    this.onLogout = this.onLogout.bind(this);
    this.fetchPeriodicCourses = this.fetchPeriodicCourses.bind(this);
  }

  public async componentDidMount() {
    const {
      isParent,
      isSchool,
      isTeacher,
      services: {
        isUserLoggedIn,
        currentUserID,
        parentsAPI,
        institutionsAPI,
        teachersAPI,
      },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
      return;
    }
    this.setState({ loaded: false });

    if (isParent) {
      const res = await parentsAPI.getCoursesSummary({
        parentID: currentUserID,
      });

      if (res.ok) {
        this.setState({ data: res.data, loaded: true });
      } else {
        alert("Error fetching parents's details!");
      }
    }

    // if (isSchool) {
    //   const res = await institutionsAPI.getCoursesSummary({
    //     institutionID: currentUserID,
    //   });
    //   if (res.ok) {
    //     this.setState({ data: res.data, loaded: true });
    //   } else {
    //     alert("Error fetching school's details!");
    //   }
    // }
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public onExploreCourse = (path) => {
    const { isParent, isSchool, isTeacher, history } = this.props;
    const { startDateObj, endDateObj } = this.state;

     history.push(`${path}`, {
       isParent,
       isSchool,
       isTeacher,
      startDateObj,
      endDateObj
     });
  }

  public onSelectCourse = (e) => {
    const selectedCourse = e.target.value;
    this.setState({ selectedCourse });
  };

  public onStartDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ startDateObj: dateObj, startDate: date });
  };

  public onEndDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ endDateObj: dateObj, endDate: date });
  };

  public async fetchPeriodicCourses() {
    this.setState({isLoading: true});
    const { startDate, endDate } = this.state;
    let res;
    const {
      services: { teachersAPI, institutionsAPI }, isSchool
    } = this.props;

    if (!startDate.length || !endDate.length) {
      toast.warn("Please make sure you have picked the correct date ranges");
      return;
    }

    if (isSchool) {
       res = await institutionsAPI.getCoursesSummary(startDate, endDate);
    } else {
          res = await teachersAPI.getAllCoursesSummary(startDate, endDate);
    }
    this.setState({ data: res.data, loaded: true, isLoading: false });
  }

  public render() {
    const { isParent, isSchool, isTeacher } = this.props;
    const { data, toLogin, selectedCourse, loaded, isLoading } = this.state;

    if (toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <Wrapper>
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <h1>
              Hi, <span>{currentUser()}</span>
            </h1>
          </ContentRow>

          {isTeacher || isSchool ? (
            <React.Fragment>
              <PickerHeader>
                Please select a time period you would like to explore
              </PickerHeader>
              <HeaderRow>
                <DatePicker
                  value={this.state.startDateObj}
                  onChange={this.onStartDateChange}
                  placeholder="Pick a start date"
                />
                <DatePicker
                  value={this.state.endDateObj}
                  onChange={this.onEndDateChange}
                  placeholder="Pick an end date"
                />
                <button
                  onClick={this.fetchPeriodicCourses}
                  className="button green-button go-action"
                >
                  GO
                </button>
              </HeaderRow>
            </React.Fragment>
          ) : (
            ""
          )}
        </Content>
        {loaded ? (
          <Content>
            <ContentRow>
              <ContentCol>
                <SummaryInfo
                  data={data}
                  isParent={isParent}
                  isSchool={isSchool}
                  isTeacher={isTeacher}
                />
                <CoursePicker
                  {...this.props}
                  data={data}
                  isParent={isParent}
                  isSchool={isSchool}
                  isTeacher={isTeacher}
                  selectedCourse={selectedCourse}
                  onSelectCourse={this.onSelectCourse}
                  onExploreCourse={this.onExploreCourse}
                />
              </ContentCol>
              <ContentCol>
                <PerformanceGraph
                  data={data}
                  isParent={isParent}
                  isSchool={isSchool}
                  isTeacher={isTeacher}
                  selectedCourse={selectedCourse}
                />
              </ContentCol>
            </ContentRow>
            {!isTeacher && !isSchool ? (
              <ContentRow className="cols-1">
                <ContentCol>
                  <StudentsPerformance
                    data={data}
                    selectedCourse={selectedCourse}
                  />
                </ContentCol>
              </ContentRow>
            ) : (
              ""
            )}
          </Content>
        ) : (
          ""
        )}

        {isLoading ? <Loader color="#acff24" /> : ""}
      </Wrapper>
    );
  }
}

export default withServices(DataCentre);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/DataCentre.tsx